import { Card } from '../components/ui';

/**
 * Quickstart. The full reference is the Swagger UI the API serves at
 * `/api-docs`; this page only covers the first five minutes so a developer can
 * make a successful call without leaving the dashboard.
 */
const API_ORIGIN = import.meta.env['VITE_API_ORIGIN'] ?? 'http://localhost:4000';

const AUTH_EXAMPLE = `curl ${API_ORIGIN}/api/v1/account \\
  -H "Authorization: Bearer sk_test_..."`;

const IDEMPOTENCY_EXAMPLE = `curl -X POST ${API_ORIGIN}/api/v1/ping \\
  -H "Authorization: Bearer sk_test_..." \\
  -H "Content-Type: application/json" \\
  -H "X-Idempotency-Key: 4f0c2e1a-..." \\
  -d '{"hello":"world"}'`;

const SIGNATURE_EXAMPLE = `const signature = crypto
  .createHmac('sha256', WEBHOOK_SECRET)
  .update(\`\${timestamp}.\${rawBody}\`)
  .digest('hex');

// Compare against X-Difference-Signature in constant time,
// and reject timestamps older than 5 minutes.`;

export function Docs() {
  return (
    <>
      <div className="page-header">
        <h1>Documentation</h1>
        <p>
          Quickstart below; the full reference lives at{' '}
          <a href={`${API_ORIGIN}/api-docs`} target="_blank" rel="noreferrer">
            {API_ORIGIN}/api-docs
          </a>
          .
        </p>
      </div>

      <div style={{ display: 'grid', gap: 16 }}>
        <Card title="Authentication">
          <div className="card-body">
            <p>
              Pass a secret key as a bearer token. Test and live keys are fully isolated — a test
              key can never touch live data.
            </p>
            <pre className="secret-reveal">{AUTH_EXAMPLE}</pre>
          </div>
        </Card>

        <Card title="Idempotency">
          <div className="card-body">
            <p>
              Send <code>X-Idempotency-Key</code> on any mutating request. Replaying the same key
              with the same body returns the original response instead of acting twice; reusing it
              with a <em>different</em> body is rejected. Keys are retained for 24 hours.
            </p>
            <pre className="secret-reveal">{IDEMPOTENCY_EXAMPLE}</pre>
          </div>
        </Card>

        <Card title="Webhook signatures">
          <div className="card-body">
            <p>
              Every delivery carries <code>X-Difference-Signature</code> and{' '}
              <code>X-Difference-Timestamp</code>. Verify over the raw request body — not the
              re-serialized JSON.
            </p>
            <pre className="secret-reveal">{SIGNATURE_EXAMPLE}</pre>
          </div>
        </Card>

        <Card title="Errors">
          <div className="card-body">
            <p>
              Failures return <code>{'{ error: { code, message, request_id } }'}</code>. Branch on{' '}
              <code>code</code>, never on the message — and quote <code>request_id</code> in support
              requests.
            </p>
          </div>
        </Card>
      </div>
    </>
  );
}
